import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';

import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import Play from 'yoda-core-components/lib/assets/svg/Play.svg';

import * as styles from './VideoContainer.css';

const cx = classNames.bind(styles);

export default class VideoContainer extends Component {
    static propTypes = {
        url: PropTypes.string.isRequired,
    };

    static defaultProps = {
        url: '',
    };

    render() {
        const { url } = this.props;
        return (
            <a href={url} target="_blank" rel="noopener noreferrer" className={cx('container')}>
                <Icon iconType="svg" className={cx('icon')} width="60px" height="60px">
                    <Play />
                </Icon>
            </a>
        );
    }
}
